/* eslint-disable import/prefer-default-export */

import { css } from '@emotion/react';

import { fluid, mq } from '../../style-tokens';

export const container = css`
  @media ${mq.tablet} {
    display: grid;
    grid-column-gap: ${fluid(2, 5)};
    grid-template-columns: repeat(2, minmax(0, 1fr));

    > *:nth-of-type(1) {
      grid-column: 1;
    }

    > *:nth-of-type(2) {
      grid-column: 2;
    }
  }
`;
